import { noop } from 'lodash';

import { Button, ButtonVariant } from '@dreryk/react-components';

import { visitActionBarTranslationKeys } from '../../../../translations';

import { withConfirmVisitSummaryActionInterceptors } from './ConfirmVisitSummaryAction.interceptors';

export type ConfirmVisitSummaryActionProps = {
   waiting: boolean;
};

export const ConfirmVisitSummaryAction = withConfirmVisitSummaryActionInterceptors((props) => {
   return (
      <Button
         order={1}
         compact
         testId={'confirmVisitAndPrint'}
         label={visitActionBarTranslationKeys.confirmAndPrint}
         variant={ButtonVariant.PRIMARY}
         onClick={noop}
         disabled={props.waiting}
         nowrap
      />
   );
});
